module.exports = __webpack_public_path__ + "img/bg-small.51b3716e.svg";